module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cb-Db-Ee-Gd.c8cfa76c.png";